import { Link } from 'react-router-dom';
import { PageHead } from '../../components/ui/PageHead';
import { Button } from '../../components/ui/Button';
import styles from './NotFoundPage.module.css';

export function NotFoundPage() {
  return (
    <>
      <PageHead title="404 - Page Not Found" />
      <div className={styles.page}>
        <div className={styles.inner}>
          <div className={styles.code} aria-hidden="true">404</div>
          <h1 className={styles.title}>Page Not Found</h1>
          <p className={styles.desc}>
            The page you're looking for doesn't exist, or may have been moved. Let's get you
            back to a valid destination.
          </p>
          <div className={styles.actions}>
            <Button to="/" variant="primary" size="lg">
              Go to Homepage
            </Button>
            <Button to="/platform" variant="ghost" size="lg">
              Explore the Platform
            </Button>
          </div>
          <div className={styles.links}>
            <span className={styles.linksLabel}>Quick links:</span>
            <Link to="/solutions" className={styles.link}>Solutions</Link>
            <Link to="/why-naats" className={styles.link}>Why NAATS</Link>
            <Link to="/contact" className={styles.link}>Contact</Link>
          </div>
        </div>
      </div>
    </>
  );
}
